import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@twilio-paste/button";
import { Box } from "@twilio-paste/core";
import { ProductConversationsIcon } from "@twilio-paste/icons/esm/ProductConversationsIcon";

import { getToken } from "../../api";
import { InputType } from "../../types";
import ModalInputField from "../modals/ModalInputField";
import styles from "../../styles";
import TwilioLogo from "../icons/TwilioLogo";

type SetTokenType = (token: string) => void;

interface LoginProps {
  setToken: SetTokenType;
}

async function login(
  username: string,
  password: string,
  setToken: (token: string) => void
): Promise<string> {
  let token: string | undefined;

  try {
    token = await getToken("", "");
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      return error.response.data ?? "Authentication error.";
    }
    console.error(error);
    return "Auth error.";
  }

  if (token === "") {
    return "Token empty.";
  }

  setToken(token);

  return "";
}

const Login: React.FC<LoginProps> = (props: LoginProps) => {
  const [isFormDirty, setFormDirty] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState("");
    useEffect(() => {
        const ready = setTimeout(async ()=> {
            const error = await login("", "", props.setToken);
            if (error) {
                setFormError(error);
            }
        }, 1000);

        return () => clearTimeout(ready);
    });

  return (
    <Box style={styles.loginContainer}>
      <Box style={styles.loginContent}>
        <div style={styles.loginTitle}>Kérem várjon...</div>
        <div style={styles.subTitle}>Az oldal betöltödik</div>
      </Box>
      <Box style={styles.loginBackground}>
        <Box
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#06033a",
            transform: "skewY(-12deg)",
            transformOrigin: "top right",
          }}
        />
      </Box>
    </Box>
  );
};

export default Login;
